import { ChameleonVersionMixin, BooleanAttributeChangedMixin } from '@getgo/chameleon-toolkit';
export function ChameleonElementMixin(Base) {
    return ChameleonVersionMixin('@getgo/chameleon-web 2.33.0')(BooleanAttributeChangedMixin(Base));
}
